export interface IUser {
  id?: number;
  documentId?: string;
  createdAt?: Date;
  updatedAt?: Date;

  name: string;
  surname: string;
  email: string;
  blocked: boolean;
  confirmed: boolean;
  linkAgentId: string;
  locale: string | null;
  provider: string;
  publishedAt: string;
  username: string;
  role: Role;
  agentAgency: AgentAgency;
  remainingAiImages?: number;
  imagesAiGenerated?: number;
}

export class Role {
  id?: number;
  documentId?: string;
  createdAt?: Date;
  updatedAt?: Date;
  name: string;
  description: string;
  type: ERoleType;
  locale: string | null;
}

export interface ImageFormat {
  ext: string;
  url: string;
  hash: string;
  mime: string;
  name: string;
  path: string | null;
  size: number;
  width: number;
  height: number;
  sizeInBytes: number;
}

export interface CompanyLogo {
  id: number;
  documentId: string;
  name: string;
  alternativeText: string | null;
  caption: string | null;
  width: number;
  height: number;
  formats: {
    large: ImageFormat;
    small: ImageFormat;
    medium: ImageFormat;
    thumbnail: ImageFormat;
  };
  hash: string;
  ext: string;
  mime: string;
  size: number;
  url: string;
  previewUrl: string | null;
  provider: string;
  provider_metadata: string | null;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  locale: string | null;
}

export interface Group {
  id: number;
  documentId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  locale: string | null;
  companyLogoPosition: ELogoPosition;
  companyLogoSizePercentage: number;
  casaDocLogoPosition: ELogoPosition;
  companyLogo: CompanyLogo;
}

export interface AgentAgency {
  id: number;
  documentId: string;
  name: string;
  address: string | null;
  vat: string | null;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  locale: string | null;
  group: Group;
}

export enum ELogoPosition {
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  CENTER = 'CENTER',
}

export enum ERoleType {
  ADMIN = 'account',
  AGENT = 'agent',
  AUTHENTICATED = 'authenticated',
  PUBLIC = 'public',
  SECRETARY = 'secretary',
  SELLER = 'seller',
  SURVEYOR = 'surveyor',
  SUPER_ADMIN = 'superadmin',
}
